<template>
  <with-actions>
    <organization-form :organization="organization" :organization_id="organization_id"></organization-form>
    <div class="row" v-if="can('write_organizations')">
      <div class="col-md-2 text-right"></div>
      <div class="col-md-8">
        <button class="btn btn-success btn-lg" @click="save($event)">Save</button>
      </div>
    </div>
  </with-actions>
</template>
<script>
import _ from 'lodash';
import Vue from 'vue';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts';
import moment from 'moment-es6';

export default {
  props: ['organization_id'],
  data: function () {
    return {
      organization: null
    };
  },
  async mounted() {
    let { data } = await Api.find('organizations', this.organization_id, {
      include: 'user_invite_mail_template,user_forgot_password_mail_template',
      fields: { mail_templates: 'id,name' }
    });
    this.organization = data;
  },
  methods: {
    save: async function (event) {
      await Api.update('organizations', this.organization)
        .then(() => {
          Alerts.success({ title: this.$i18n.t('saved'), detail: '' });
        })
        .catch(({ errors }) => {
          Alerts.danger({ title: errors[0].title, detail: '' });
        });
    }
  },
  asyncComputed: {}
};
</script>
